import { memo } from "react";
import { ContractWidgetProps } from "./types";
import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import ContractStatsTab from "./components/ContractStatsTab/ContractStatsTab";
import ContractSaleSearchTab from "./components/ContractSearchTab/ContractSaleSearchTab";
import ContractRentSearchTab from "./components/ContractSearchTab/ContractRentSearchTab";

const ContractWidget: React.FC<ContractWidgetProps> = () => {
  const { t } = useTranslate();

  return (
    <Tabs
      tabs={[
        {
          label: t("admin.dashboard.widget.contracts.tab.stats.title"),
          content: <ContractStatsTab />,
        },
        {
          label: t("admin.dashboard.widget.contracts.tab.search.sale.title"),
          content: <ContractSaleSearchTab />,
        },
        {
          label: t("admin.dashboard.widget.contracts.tab.search.rent.title"),
          content: <ContractRentSearchTab />,
        },
      ]}
    />
  );
};

export default memo(ContractWidget);
